const baseURL = 'https://xcaret.quickplate.cloud/';

export default baseURL;
